export default function RevenueSummary({ subscriptions, settings, totalMembers }) {
  const currency = settings.currency || 'ZMW'
  const fee = Number(settings.member_subscription_fee || 50)
  const currentYear = new Date().getFullYear()

  const thisYearSubs = subscriptions.filter(s => new Date(s.payment_date).getFullYear() === currentYear)
  const totalRevenue = thisYearSubs.reduce((sum, s) => sum + Number(s.amount), 0)
  const paidMembers = new Set(thisYearSubs.map(s => s.supporter_id)).size
  const unpaidMembers = totalMembers - paidMembers
  const outstanding = unpaidMembers * fee
  const collectionRate = totalMembers > 0 ? Math.round((paidMembers / totalMembers) * 100) : 0

  const cards = [
    { label: `Revenue (${currentYear})`, value: `${currency} ${totalRevenue.toLocaleString()}`, color: 'text-green-600 dark:text-green-400' },
    { label: 'Outstanding', value: `${currency} ${outstanding.toLocaleString()}`, color: 'text-red-500 dark:text-red-400' },
    { label: 'Collection Rate', value: `${collectionRate}%`, color: collectionRate >= 75 ? 'text-green-600 dark:text-green-400' : collectionRate >= 50 ? 'text-yellow-600 dark:text-yellow-400' : 'text-red-500 dark:text-red-400' },
    { label: 'Paid Members', value: `${paidMembers} / ${totalMembers}`, color: 'text-gray-900 dark:text-white' },
  ]

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 lg:gap-4">
      {cards.map((card) => (
        <div key={card.label} className="bg-gray-100 dark:bg-white/5 border border-gray-200 dark:border-white/10 p-4 lg:p-6">
          <div className={`text-xl sm:text-2xl lg:text-3xl font-black mb-2 ${card.color}`}>{card.value}</div>
          <div className="text-xs text-gray-500 uppercase tracking-widest font-semibold">{card.label}</div>
        </div>
      ))}
    </div>
  )
}